import { Alert } from '@uhg-abyss/web/ui/Alert';
import find from 'lodash/find';
import { useTranslation } from 'react-i18next';

import { useLagoon } from '../../hooks/useLagoon';
import { ProviderType } from '../../models/ProviderDetails';
import { parseProviderName } from '../../utils/providerNames.utils';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { ContentWrapper } from '../ContentWrapper';
import { BannerTitle } from './ReferralRequestBanner.style';

type Props = {
  providerName: string;
  status?: string;
  onClickLink: (status: string | undefined) => void;
  nameAttrs: any;
  providerType: ProviderType;
  professionalDesignation: string;
};

export const ReferralRequestBanner = ({
  providerName,
  status,
  onClickLink,
  nameAttrs,
  providerType,
  professionalDesignation,
}: Props) => {
  const { t } = useTranslation();
  const formatedProviderName = parseProviderName(
    providerName,
    providerType,
    professionalDesignation,
    nameAttrs
  );

  const data = (useLagoon('ui-messaging') as () => any[])();

  const defaultContent = find(data, {
    key: ConstantsLagoon.REFERRAL_REQUEST_BANNER
      .REFERRAL_REQUEST_BANNER_CONTENT,
  });

  let title: string;
  let buttonText: string;
  let alertStatus: 'success' | 'info' | 'error' | 'warning';
  let borderColor: string;
  const onCtaClick = () => {
    onClickLink(status);
  };

  if (
    status === 'NO_REFERRAL' ||
    status === 'EXPIRED' ||
    status === 'REJECTED' ||
    status === 'DENIED'
  ) {
    title = `${t(
      'REFERRAL_BANNER_MESSAGE.REFERRAL_REQUIRED'
    )} ${formatedProviderName}`;
    buttonText = `${t('REFERRAL_BANNER_LINK.REFERRAL_REQUIRED')}`;
    alertStatus = 'warning';
    borderColor = '#BFDBBF';
  } else if (status === 'PENDING_APPROVAL') {
    title = `${t(
      'REFERRAL_BANNER_MESSAGE.REFERRAL_REQUEST_SENT'
    )} ${formatedProviderName} ${t('REFERRAL_BANNER_MESSAGE.HAS_BEEN_SENT')}`;
    buttonText = `${t('REFERRAL_BANNER_LINK.REFERRAL_REQUEST_SENT')}`;
    alertStatus = 'info';
    borderColor = '#126ECF';
  } else if (status === 'ACTIVE' || status === 'EXPIRING') {
    title = `${t(
      'REFERRAL_BANNER_MESSAGE.REFERRAL_APPROVED'
    )} ${formatedProviderName}`;
    buttonText = `${t('REFERRAL_BANNER_LINK.REFERRAL_APPROVED')}`;
    alertStatus = 'success';
    borderColor = '#E8C0C0';
  } else if (status === 'ERROR') {
    title = `${t(
      'REFERRAL_BANNER_MESSAGE.REFERRAL_ERROR'
    )} ${formatedProviderName}`;
    buttonText = `${t('REFERRAL_BANNER_LINK.REFERRAL_ERROR')}`;
    alertStatus = 'error';
    borderColor = '#E8C0C0';
  } else {
    title = `${formatedProviderName} ${defaultContent?.title}`;
    buttonText = defaultContent?.message;
    alertStatus = 'warning';
    borderColor = '#F3D8C0';
  }

  return (
    <>
      <ContentWrapper>
        <Alert
          children=""
          css={{
            'abyss-alert-root': {
              borderTop: `1px solid ${borderColor}`,
              borderBottom: `1px solid ${borderColor}`,
            },
          }}
          cta={{
            type: 'link',
            props: {
              children: buttonText,
              onClick: onCtaClick,
            },
          }}
          dismissible={false}
          isVisible={true}
          status={alertStatus}
          title={(<BannerTitle>{title}</BannerTitle>) as any}
        />
      </ContentWrapper>
    </>
  );
};
